<template>
  <div>
    <andes-header></andes-header>

    <div class="container change-page">
      <div class="row">
        <div class="col-sm-9">

          <div class="row">
            <div class="col-12">
              <div class="current-srch-container">
                <div class="row d-flex align-items-center text-center text-sm-left">
                  <div class="col-12 col-sm-6">
                    <h4 class="m-0">{{ $t('MODIFICAR RESERVA') }}</h4>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="reservation text-center">{{ $t('Reserva:') }} {{ booking.RecordLocator }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="alert alert-danger" v-if="error">{{ $t(error) }}</div>
          <div class="alert alert-warning" v-if="options && !options.Allowed">
            {{ $t(options.Message || 'Esta reserva no puede modificarse online.') }}
          </div>

          <!-- PASO 1: QUE VUELO MODIFICAR -->
          <div v-if="step === 1 && options && options.Allowed">
            <h5 class="mb-3">{{ $t('¿Qué vuelo querés modificar?') }}</h5>
            <div class="card shadow mb-3" v-for="flight of options.Flights" :key="flight.FlightKey">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <div class="flight-route">
                      {{ flight.DepartureStation }} → {{ flight.ArrivalStation }}
                      <span class="flight-number" v-if="flight.FlightNumber">· {{ flight.FlightNumber }}</span>
                    </div>
                    <div class="text-muted">
                      {{ formatDateTime(flight.STD) }}
                      <span v-if="flight.ProductName">· {{ flight.ProductName }}</span>
                    </div>
                    <div class="text-muted" v-if="flight.Allowed && penaltyOf(flight) > 0">
                      Penalidad por cambio: ARS {{ toCurrencyFormat(flight.PenaltyTotal) }}
                      <span v-if="flight.PassengerCount > 1">({{ flight.PassengerCount }} pasajeros)</span>
                    </div>
                    <div class="text-muted" v-else-if="flight.Allowed">{{ $t('Sin penalidad por cambio') }}</div>
                    <div class="text-danger" v-if="!flight.Allowed">{{ $t(flight.Message) }}</div>
                  </div>
                  <button type="button" class="btn btn-andes mt-2"
                          :disabled="!flight.Allowed || loading" @click="pickFlight(flight)">
                    Modificar
                  </button>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-andes" @click="backToItinerary">{{ $t('Volver al itinerario') }}</button>
          </div>

          <!-- PASO 2: NUEVO VUELO -->
          <div v-if="step === 2">

            <!-- Datos del tramo que se está modificando -->
            <div class="row" v-if="selectedFlight">
              <div class="col-12">
                <div class="current-srch-container">
                  <h4 class="compact-srch-title">{{ $t('Vuelo a modificar:') }}</h4>
                  <div class="current-srch-data">
                    <div class="current-srch-ond">
                      <h1>
                        {{ selectedFlight.DepartureStation }}
                        <img src="@/img/plane-32.png" alt="Vuela a">
                        {{ selectedFlight.ArrivalStation }}
                      </h1>
                    </div>
                    <div class="current-srch-date">
                      <div class="current-srch-icon-box"></div>
                      <div class="current-srch-date-box">
                        <div class="current-srch-day">
                          <p>{{ dayNumber(selectedFlight.DepartureDate) }}</p>
                          <p>{{ getMonth(selectedFlight.DepartureDate) }}</p>
                        </div>
                        <div class="current-srch-year">
                          <p>{{ yearNumber(selectedFlight.DepartureDate) }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <table class="table segment-detail mb-3">
                  <tr>
                    <th>Vuelo</th>
                    <td>{{ selectedFlight.FlightNumber }}</td>
                    <th>Horario</th>
                    <td>{{ onlyTime(selectedFlight.STD) }} - {{ onlyTime(selectedFlight.STA) }}</td>
                  </tr>
                  <tr>
                    <th>Tarifa</th>
                    <td>
                      {{ selectedFlight.ProductName || selectedFlight.ProductClassCode }}
                      <span class="text-muted" v-if="selectedFlight.ClassOfService">
                        (clase {{ selectedFlight.ClassOfService }})
                      </span>
                    </td>
                    <th>{{ $t('Pasajeros') }}</th>
                    <td>{{ selectedFlight.PassengerCount }}</td>
                  </tr>
                </table>

              </div>
            </div>

            <div class="form-row align-items-end mb-3">
              <div class="form-group col-12 col-sm-5 mb-2">
                <label for="newDate">Nueva fecha</label>
                <input type="date" id="newDate" class="form-control"
                       v-model="searchDate" :min="today">
              </div>
              <div class="form-group col-12 col-sm-3 mb-2">
                <button type="button" class="btn btn-andes btn-block"
                        :disabled="loading || !searchDate" @click="search">
                  BUSCAR
                </button>
              </div>
            </div>

            <div class="row" v-if="searched">
              <div class="col-12">
                <div class="avail-header">
                  <h4>{{ $t('NUEVO VUELO') }}</h4>
                </div>

                <div class="low-fare-tab-container">
                  <ul class="low-fare-tabs">
                    <li class="low-fare-arrow low-fare-left-arrow"></li>
                    <li v-for="d of weekDays" :key="d" :class="tabClass(d)">
                      <a @click="setSearchDate(d)">
                        <div class="fare month">{{ getMonth(d) }}</div>
                        <div class="low-fare-date">{{ getDay(d) }}</div>
                        <div class="low-fare-price">{{ getWeekFare(d) }}</div>
                      </a>
                    </li>
                    <li class="low-fare-arrow low-fare-right-arrow"></li>
                  </ul>

                  <table class="table avail-table d-none d-md-block" v-if="flights.length > 0">
                    <tr>
                      <th class="align-bottom">{{ $t('Salida') }}</th>
                      <th class="align-bottom">{{ $t('Llegada') }}</th>
                      <th class="align-bottom">{{ $t('Duración') }}</th>
                      <th class="align-bottom">Vuelo</th>
                      <th class="tab-basico">
                        <div class="tag">Basico</div>
                        <fare-class-tooltip-detail product-class-id="A" :fare-rule="fareRuleFor('A')"></fare-class-tooltip-detail>
                      </th>
                      <th class="tab-intermedio">
                        <div class="tag">Intermedio <br>
                          <img src="@/img/PassengerSeat-32x32_white.png" style="width:20px"/>
                          <font-awesome-icon icon="plus"/>
                          <font-awesome-icon icon="briefcase" size="1x"/>
                          <fare-class-tooltip-detail product-class-id="B" :fare-rule="fareRuleFor('B')"></fare-class-tooltip-detail>
                        </div>
                      </th>
                      <th class="tab-premium">
                        <div class="tag">{{ $t('Premium') }} <br>
                          <img src="@/img/PassengerSeat-32x32_white.png" style="width:20px"/>
                          <font-awesome-icon icon="plus"/>
                          <font-awesome-icon icon="briefcase" size="1x"/>
                          <font-awesome-icon icon="plus"/>
                          <font-awesome-icon icon="sync" size="1x"/>
                          <fare-class-tooltip-detail product-class-id="M" :fare-rule="fareRuleFor('M')"></fare-class-tooltip-detail>
                        </div>
                      </th>
                    </tr>
                    <tr class="avail-data-row" v-for="f of flights" :key="f.FlightNumber">
                      <td><div class="text-center">{{ f.STDTime }}</div></td>
                      <td><div class="text-center">{{ f.STATime }}</div></td>
                      <td>
                        <div class="text-center">{{ escalasTxt(f) }}</div>
                        <div class="text-center">{{ getDuration(f) }}hs</div>
                      </td>
                      <td><div class="text-center">{{ f.FlightNumber }}</div></td>
                      <template v-for="clazz of productClasses">
                        <td class="avail-table-price" :key="clazz" v-if="getFare(f, clazz)">
                          <a :class="{'is-checked': isSelected(getFare(f, clazz))}"
                             @click="select(getFare(f, clazz))">{{ getFareString(f, clazz) }}</a>
                          <p v-if="getLid(f, clazz) < 6">{{ getLid(f, clazz) }} asientos libres</p>
                          <span class="tarifa-clase">{{ getClassOfServiceString(f, clazz) }}</span>
                        </td>
                        <td class="avail-table-price" :key="clazz + '-empty'" v-else>-</td>
                      </template>
                    </tr>
                  </table>

                  <table class="flight-info-mobile-table d-block d-md-block d-lg-none"
                         v-if="flights.length > 0">
                    <tr>
                      <th></th>
                      <th class="tab-basico">Basico</th>
                      <th class="tab-intermedio">Intermedio</th>
                      <th class="tab-premium">Premium</th>
                    </tr>
                    <tr class="flight-info-mobile-table-data" v-for="f of flights" :key="f.FlightNumber">
                      <td>
                        <p>{{ f.STDTime }}</p>
                        <p>{{ f.STATime }}</p>
                        <p><strong>Vuelo {{ f.FlightNumber }}</strong></p>
                      </td>
                      <template v-for="clazz of productClasses">
                        <td :key="clazz" v-if="getFare(f, clazz)">
                          <p :class="{'is-checked': isSelected(getFare(f, clazz))}"
                             @click="select(getFare(f, clazz))">{{ getFareString(f, clazz) }}</p>
                          <p v-if="getLid(f, clazz) < 6">{{ getLid(f, clazz) }} asientos libres</p>
                          <p>{{ getClassOfServiceString(f, clazz) }}</p>
                        </td>
                        <td :key="clazz + '-empty'" v-else>-</td>
                      </template>
                    </tr>
                  </table>

                  <div class="avail-info-no-flights" v-else>
                    <h3>Este vuelo no tiene asientos disponibles. Te invitamos a buscar en otra fecha.</h3>
                  </div>

                  <a v-if="flights.length > 0" class="fare_link_detail" target="_blank"
                     href="https://www.andesonline.com/informacion/condiciones-de-tarifas/">
                    (*) Ver condiciones de tarifas
                  </a>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between flex-wrap mt-3">
              <button type="button" class="btn btn-andes mb-2" :disabled="loading"
                      @click="step = 1">VOLVER</button>
              <button type="button" class="btn btn-andes mb-2" v-if="selectedFare"
                      :disabled="loading" @click="quoteSelectedFare">CONTINUAR</button>
            </div>
          </div>

          <!-- PASO 3: COTIZACION Y PAGO -->
          <div v-if="step === 3 && change">
            <h5 class="mb-3">Confirmá el cambio</h5>
            <div class="card shadow mb-3">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <p class="text-muted mb-1">Vuelo actual</p>
                    <p class="mb-0">
                      {{ change.DepartureStation }} → {{ change.ArrivalStation }}<br>
                      {{ formatDate(change.OldDepartureDate) }}
                      <span v-if="change.OldFlightNumber">· {{ change.OldFlightNumber }}</span>
                    </p>
                  </div>
                  <div class="col-sm-6">
                    <p class="text-muted mb-1">Nuevo vuelo</p>
                    <p class="mb-0">
                      {{ change.DepartureStation }} → {{ change.ArrivalStation }}<br>
                      {{ formatDate(change.DepartureDate) }}
                      <span v-if="change.FlightNumber">· {{ change.FlightNumber }}</span>
                    </p>
                  </div>
                </div>
                <hr>
                <div class="d-flex justify-content-between">
                  <span>Diferencia de tarifa</span>
                  <span>ARS {{ toCurrencyFormat(change.FareDifference) }}</span>
                </div>
                <div class="d-flex justify-content-between" v-if="parseFloat(change.PenaltyTotal || 0) > 0">
                  <span>{{ change.PenaltyFeeName || 'Penalidad por cambio' }}</span>
                  <span>ARS {{ toCurrencyFormat(change.PenaltyTotal) }}</span>
                </div>
                <hr>
                <h3 class="total-title">
                  {{ $t('TOTAL A PAGAR:') }} <span>ARS {{ toCurrencyFormat(change.TotalAmount) }}</span>
                </h3>
                <p class="text-muted mt-3 mb-0">
                  El cambio se aplica una vez acreditado el pago. Hasta ese momento tu vuelo actual
                  sigue vigente. Si elegiste asiento, tendrás que volver a elegirlo en el nuevo vuelo.
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-between flex-wrap">
              <button type="button" class="btn btn-andes mb-2" :disabled="loading" @click="discardQuote">
                Cancelar
              </button>
              <button type="button" class="btn btn-andes mb-2" :disabled="loading" @click="pay">
                Pagar y confirmar cambio
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <andes-footer/>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import AndesHeader from "../components/AndesHeader";
  import AndesFooter from "../components/AndesFooter";
  import LoadingModal from "../components/LoadingModal";
  import { formatMoney } from "../utils/utils";
  import FareClassTooltipDetail from "../components/flight/FareClassTooltipDetail";
  import {
    cancelBookingChange,
    getChangeAvailability,
    getChangeOptions,
    payBookingChange,
    quoteBookingChange,
  } from '@/api/api';
  var moment = require('moment');

  export default {
    name: 'change-flight-page',
    components: {
      AndesHeader,
      AndesFooter,
      LoadingModal,
      FareClassTooltipDetail,
    },
    computed: {
      ...mapState(['booking', 'loading']),
      today: function () {
        return moment().format('YYYY-MM-DD');
      },
      // Misma ventana que la búsqueda original: la fecha elegida queda al centro.
      weekDays: function () {
        if (!this.searchDate) return [];
        let day = moment(this.searchDate).add(-4, 'days');
        let days = [];
        for (let i = 0; i < 7; i++) {
          days.push(day.add(1, 'days').format('YYYY-MM-DD'));
        }
        return days;
      },
      flights: function () {
        let byFlightNumber = (this.offers || {})[this.searchDate];
        if (!byFlightNumber) return [];
        return Object.keys(byFlightNumber).map((n) => byFlightNumber[n]);
      },
    },
    data: function () {
      return {
        step: 1,
        options: null,
        selectedFlight: null,
        offers: null,
        searchDate: null,
        searched: false,
        selectedFare: null,
        productClasses: ['A', 'B', 'M'],
        fareRules: {},
        change: null,
        error: null,
      };
    },
    methods: {
      toCurrencyFormat: function (amount) {
        return formatMoney(parseFloat(amount || 0));
      },
      formatDate: function (value) {
        if (!value) return '';
        return moment(value).locale('es').format('dddd DD MMM YYYY');
      },
      formatDateTime: function (value) {
        if (!value) return '';
        return moment(value).locale('es').format('dddd DD MMM YYYY HH:mm');
      },
      penaltyOf: function (flight) {
        return parseFloat((flight && flight.PenaltyTotal) || 0);
      },
      onError: function (err) {
        this.$store.commit('loading', false);
        this.error = typeof err === 'string' ? err : this.$t('No se pudo completar la operación.');
      },
      backToItinerary: function () {
        this.$router.replace('itinerary');
      },
      load: function () {
        this.error = null;
        this.$store.commit('loading', true);
        getChangeOptions(this.booking.BookingID, (result) => {
          this.$store.commit('loading', false);
          this.options = result;
          if (result && result.Change && result.Change.IsOpen) {
            this.change = result.Change;
            this.step = 3;
          }
        }, this.onError);
      },
      pickFlight: function (flight) {
        this.selectedFlight = flight;
        this.step = 2;
        // Nada se busca hasta que el pasajero elija una fecha y presione BUSCAR.
        this.offers = null;
        this.searchDate = null;
        this.searched = false;
        this.selectedFare = null;
        this.fareRules = {};
      },
      fareRuleFor: function (productClassId) {
        return (this.fareRules && this.fareRules[productClassId]) || null;
      },
      search: function () {
        if (!this.searchDate) return;
        this.error = null;
        this.selectedFare = null;
        this.$store.commit('loading', true);
        getChangeAvailability({
          BookingID: this.booking.BookingID,
          SegmentID: this.selectedFlight.SegmentID,
          DepartureDateStart: this.weekDays[0],
          DepartureDateEnd: this.weekDays[this.weekDays.length - 1],
        }, (result) => {
          this.$store.commit('loading', false);
          this.offers = result.Flights || {};
          this.fareRules = result.FareRules || {};
          this.searched = true;
        }, this.onError);
      },
      setSearchDate: function (date) {
        this.searchDate = date;
        this.search();
      },
      tabClass: function (date) {
        let clazz = '';
        let index = this.weekDays.indexOf(date);
        if (index === 0 || index === 6) {
          clazz = 'd-none d-md-none d-md-inline-block ';
        }
        return date === this.searchDate ? clazz + 'active-fare-tab' : clazz;
      },
      getMonth: function (date) {
        return moment(date).locale('es').format('MMM');
      },
      getDay: function (date) {
        return moment(date).locale('es').format('ddd DD');
      },
      dayNumber: function (date) {
        return moment(date).locale('es').format('DD');
      },
      yearNumber: function (date) {
        return moment(date).locale('es').format('YYYY');
      },
      onlyTime: function (value) {
        if (!value) return '';
        return moment(value).format('HH:mm');
      },
      getWeekFare: function (date) {
        let byFlightNumber = (this.offers || {})[date];
        let cheapest = null;
        for (let number in byFlightNumber) {
          for (let fare of byFlightNumber[number].Fares || []) {
            if (!cheapest || this.payableOf(fare) < this.payableOf(cheapest)) {
              cheapest = fare;
            }
          }
        }
        if (!cheapest) return '-';
        return this.payableString(cheapest);
      },
      getFare: function (flight, clazz) {
        for (let fare of flight.Fares || []) {
          if (fare.ProductClassId === clazz) return fare;
        }
        return null;
      },
      getLid: function (flight, clazz) {
        let fare = this.getFare(flight, clazz);
        return fare ? fare.Lid : null;
      },
      // Lo que el pasajero paga por elegir esta tarifa, no el precio del pasaje:
      // diferencia de tarifa más penalidad, tal como lo calcula la cotización.
      payableOf: function (fare) {
        return parseFloat((fare && fare.PayableAmount) || 0);
      },
      payableString: function (fare) {
        let payable = this.payableOf(fare);
        if (payable <= 0) return this.$t('Sin cargo');
        return '+ ' + (fare.Currency || 'ARS') + ' ' + formatMoney(payable);
      },
      getFareString: function (flight, clazz) {
        let fare = this.getFare(flight, clazz);
        if (!fare) return '-';
        return this.payableString(fare);
      },
      getClassOfServiceString: function (flight, clazz) {
        let fare = this.getFare(flight, clazz);
        return fare ? 'Tarifa clase ' + fare.ClassOfService : '';
      },
      getDuration: function (flight) {
        if (!flight.STD || !flight.STA) return '';
        let departure = moment(flight.STD);
        let arrival = moment(flight.STA);
        return moment.utc(arrival.diff(departure)).format('HH:mm');
      },
      escalasTxt: function (flight) {
        let stops = (flight.LegIDs || '').split(',').length - 1;
        if (stops <= 0) return this.$t('Sin escalas');
        if (stops === 1) return '1 escala';
        return stops + ' escalas';
      },
      select: function (fare) {
        this.selectedFare = fare;
      },
      isSelected: function (fare) {
        return !!fare && !!this.selectedFare && this.selectedFare.SalesKey === fare.SalesKey;
      },
      quoteSelectedFare: function () {
        if (this.selectedFare) this.pickFare(this.selectedFare);
      },
      pickFare: function (fare) {
        this.error = null;
        this.$store.commit('loading', true);
        quoteBookingChange({
          BookingID: this.booking.BookingID,
          SegmentID: this.selectedFlight.SegmentID,
          SalesKey: fare.SalesKey,
        }, (result) => {
          this.$store.commit('loading', false);
          this.change = result.Change;
          if (result.Booking) {
            this.$store.dispatch('updateBooking', result.Booking);
          }
          this.step = 3;
        }, this.onError);
      },
      discardQuote: function () {
        this.$store.commit('loading', true);
        cancelBookingChange(this.booking.BookingID, () => {
          this.$store.commit('loading', false);
          this.change = null;
          this.step = 1;
          this.load();
        }, this.onError);
      },
      pay: function () {
        this.error = null;
        this.$store.commit('loading', true);
        payBookingChange({
          BookingID: this.booking.BookingID,
          RecordLocator: this.booking.RecordLocator,
          ChangeID: this.change.id,
        }, (result) => {
          if (result && result.URL) {
            window.location.href = result.URL;
            return;
          }
          this.$store.commit('loading', false);
          this.error = (result && result.message) || this.$t('No se pudo iniciar el pago del cambio.');
        }, this.onError);
      },
    },
    mounted() {
      this.$store.commit('loading', false);
      if (!this.booking || !this.booking.BookingID) {
        this.$router.replace('/');
        return;
      }
      this.load();
    },
  }
</script>

<style scoped>
.flight-route {
  font-weight: bold;
}
.flight-number {
  font-weight: normal;
}
.segment-detail th {
  border-top: none;
  font-weight: 600;
  width: 22%;
}
.segment-detail td {
  border-top: none;
}
</style>
